import { makeStyles } from "@material-ui/core/styles";

const bHeight = 8;
const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        backgroundColor: theme.palette.primary.light,
        flexDirection: "column",
        height: "100vh",
        alignItems: "center",
    },
    welcome: {
        color: theme.palette.primary.dark,
        fontWeight: "bold",
        fontSize: "5.5rem",
        marginBottom: "8rem",
    },
    enter: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        height: `${bHeight}rem`,
        width: `${bHeight * 3}rem`,
        fontWeight: "bold",
        fontSize: `${bHeight / 5}rem`
    }
}));

export default useStyles;
